<template>
  <fin-data-loader :resolver="query">
    <template #content="{data}">
      <fin-data-slider
        v-if="(data && data.searchFinancialDataHistograms && data.searchFinancialDataHistograms.items && data.searchFinancialDataHistograms.items.length >= 1) && data.searchFinancialDataHistograms.items[0].bins.length>2"
        :items="data.searchFinancialDataHistograms.items[0].bins"
        :max="data.searchFinancialDataHistograms.items[0].binLast"
        :min="data.searchFinancialDataHistograms.items[0].binFirst"
        :step="data.searchFinancialDataHistograms.items[0].binInterval"
        :value="value"
        @input="val => $emit('input', val)"
        @delete="$emit('delete')"
        open-end
        open-start/>
      <fin-data-slider
        v-else
        :value="value"
        @input="val => $emit('input', val)"
        @delete="$emit('delete')"
      />
    </template>
  </fin-data-loader>

</template>

<script>
import FinDataSlider from '@/components/pages/finTools/finScreener/screenerMask/dataSlider/index'
import {searchFinancialDataHistograms} from '@/js/finQueries'
import FinDataLoader from "@/components/common/DataLoader/index"

export default {
  name: 'FinScreenerDataSlider',
  components: {FinDataLoader, FinDataSlider},
  props: {
    value: {
      type: Array
    },
    region: {
      type: String,
      default: 'ALL'
    },
    sector: {
      type: String,
      default: 'ALL'
    },
    marketCap: {
      type: String,
      default: 'ALL'
    },
    assetClass: {
      type: String
    },
    position: {
      type: Object,
      required: true
    },
    screenerType: {
      type: String,
      required: true
    },
  },
  computed: {
    query() {
      let filter = undefined
      let additionalFields = undefined
      if (this.screenerType === "shareScreener") {
        filter = {
          financialDataHistogramDataItemId: {eq: this.position.id},
          financialDataHistogramRegionId: {eq: this.region},
          financialDataHistogramSectorId: {eq: this.sector},
          financialDataHistogramMarketCapId: {eq: this.marketCap},
          binCount: {
            gt: 1
          }
        }
        additionalFields = ['financialDataHistogramRegionId',
          'financialDataHistogramSectorId',
          'financialDataHistogramMarketCapId'
        ]
      } else if (this.screenerType === "etfScreener") {
        filter = {
          financialDataHistogramDataItemId: {eq: this.position.id},
          assetClass: {eq: this.assetClass},
          binCount: {
            gt: 1
          }
        }
        additionalFields = ['assetClass']
      }

      return this.$Amplify.graphqlOperation(searchFinancialDataHistograms(additionalFields), {limit: 1, filter})
    }
  }
}
</script>

<style scoped>

</style>
